import { CoralogixRum } from '@coralogix/browser'

import environment from '@/environment'
import {
  isAxiosRequestCanceledEvent,
  isNetworkErrorEvent,
  isTokenExpiredEvent,
} from '@/features/coralogix/utils/checks'
import { shouldInitializeCoralogixRum } from '@/features/coralogix/utils/shouldInitializeCoralogixRum'

export function initCoralogixRum() {
  if (CoralogixRum.isInited) return

  if (!shouldInitializeCoralogixRum()) return

  const publicKey = environment.coralogixRumPublicKey?.trim()
  if (!publicKey) {
    if (['staging', 'production'].includes(environment.environmentName)) {
      console.warn('Coralogix RUM public key missing; Coralogix RUM disabled.')
    }
    return
  }

  CoralogixRum.init({
    public_key: publicKey,
    application: environment.environmentName,
    version: environment.deployedVersion,
    coralogixDomain: 'EU2',
    ignoreErrors: ['ResizeObserver loop completed with undelivered notifications'],
    beforeSend: (event) => {
      if (isTokenExpiredEvent(event)) return null
      if (isAxiosRequestCanceledEvent(event)) return null
      if (isNetworkErrorEvent(event)) return null
      return event
    },
    sessionConfig: {
      sessionSampleRate: 30, // % of sessions tracked at random
      alwaysTrackSessionsWithErrors: true,
    },
    sessionRecordingConfig: {
      enable: true,
      autoStartSessionRecording: true,
      // Mask all text and block media in session replay.
      maskAllInputs: true,
      maskTextSelector: '*',
      blockSelector: 'img,video,audio,picture,source,iframe,embed,object,canvas',
      sessionRecordingSampleRate: 100,
    },
    traceParentInHeader: {
      enabled: true,
      options: {
        propagateTraceHeaderCorsUrls: [/^https:\/\/api\.([^/.]+\.)*sympower\.net(\/|$)/],
      },
    },
  })
}
